import { render, staticRenderFns } from "./PO-Line-Item.vue?vue&type=template&id=f4faa096"
import script from "./PO-Line-Item.vue?vue&type=script&lang=js"
export * from "./PO-Line-Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports